import React, { useState, useEffect, useRef, useContext } from "react";
import classnames from "classnames";
import { UpdateDispatchContext } from "components/SummonerProfiles/SummonerProfileUpdateReducer";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { usePrevious, useQueryString } from "hooks/general-hooks";
import { useValidateURL } from "components/SummonerProfiles/SharedFuncs";
import ChampionStatsTable from "./ChampionStatsTable";
import { usePlayerStatistics } from "api/summonerProfileApi";
import { roleMapping, queueTypeMapping } from "api/apiHelpers.js";
import { useValidateQueryParams } from "query_parameters/paramsHelper";
import { QUEUE_TYPE_ID_MAP, QUEUE_TYPE_RANKED } from "query_parameters/filter_options_profile";
import { INTERNAL_CURRENT_SEASON } from "@ugg/shared/constants/seasons";

const SummonerChampionStats = (props) => {
  const dispatch = useContext(UpdateDispatchContext);
  const context = getSummonerProfileContext();
  const { page, summonerName, region, isUpdatingProfile } = context;
  const [filterChanged, setFiltersChanged] = useState(false);
  const queryString = useQueryString();
  const validateQueryParams = useValidateQueryParams();
  const validateURL = useValidateURL();
  const location = useLocation();
  const prevSearch = useRef(location.search);
  const history = useHistory();
  const prevProps = usePrevious(props);

  const validatedParams = validateQueryParams({
    queryParams: queryString,
    page,
    queryParamType: "profile",
    keepDefaultParams: true,
  });
  const queueType = QUEUE_TYPE_ID_MAP[validatedParams.queueType];
  const isRanked = QUEUE_TYPE_RANKED.includes(validatedParams.queueType);

  const { data, loading, error, refetch, variables } = usePlayerStatistics(
    summonerName,
    region,
    {
      queueType,
      seasonId: parseInt(validatedParams.season),
      role: parseInt(roleMapping(validatedParams.role)),
    },
    { fetchPolicy: isUpdatingProfile || filterChanged ? "network-only" : "cache-first" },
  );

  const { fetchPlayerStatistics } = data || {};
  const champions = (fetchPlayerStatistics || []).reduce((acc, curr) => {
    return acc.concat(curr.basicChampionPerformances);
  }, []);

  useEffect(() => {
    if (prevSearch.current !== location.search) {
      setFiltersChanged(true);
    }
  }, [location.search]);

  useEffect(() => {
    validateURL(prevProps, props, { location, queryString, history, page });
  }, [page, location.pathname]);

  useEffect(() => {
    dispatch({
      type: "addUpdates",
      payload: { playerChampionStats: refetch },
    });
  }, [JSON.stringify(variables)]);

  const pageClassNames = classnames("summoner-profile_champion-stats", {
    "summoner-profile_champion-stats_loading": loading,
  });

  return (
    <div className={pageClassNames}>
      {loading ? (
        <div className="spinthatshit-loader">
          <div className="spinner" />
        </div>
      ) : (
        <ChampionStatsTable
          isRanked={isRanked}
          data={champions}
          hideLP={parseInt(validatedParams.season) !== INTERNAL_CURRENT_SEASON}
        />
      )}
    </div>
  );
};

export default SummonerChampionStats;
